/**
 * Converts signature or stamp (canvas or blob URL) to a File ready for API
 * @param {string | HTMLCanvasElement} source - canvas element or blob URL
 * @param {string} filename - file name for backend
 * @returns {Promise<File>}
 */
export default function useExportSignature() {
  const exportSignature = async (source, filename = "signature.png") => {
    if (!source) return null;

    let blob;

    if (typeof source === "string" && source.startsWith("blob:")) {
      // Convert blob URL to blob
      blob = await fetch(source).then((res) => res.blob());
    } else if (source instanceof HTMLCanvasElement) {
      // Canvas to blob
      blob = await new Promise((resolve) =>
        source.toBlob(resolve, "image/png")
      );
    } else {
      // Already a File/Blob?
      blob = source;
    }

    if (!blob) return null;

    return new File([blob], filename, { type: "image/png" });
  };

  return exportSignature;
}
